<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Parental Menu Control</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
               <v-col cols="12" sm="4" md="4">
                <p><v-icon color="error">*</v-icon><b>Child</b></p>
                <v-autocomplete color="#0F2027" dense rounded required @change="fetchData()" v-model="child" :items="child_list" item-text="learner" item-value="id" label="Child" outlined persistent-hint hint="Please Select Child" />
            </v-col>
               <!-- <v-col cols="12" sm="4" md="4" v-if="menu_type_list!=''">
                <p><v-icon color="error">*</v-icon><b>Menu Type </b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="menu_type" :items="menu_type_list" item-text="name" item-value="id" label="Menu Type" outlined persistent-hint hint="Please Select Menu Type" />
            </v-col> -->
            </v-row>
             <!-- <v-row justify="center" dense>
             <v-col col="12" sm="2" md="2" class="pt-6 mt-6" v-if="this.child">
                        <v-btn color="warning" @click="fetchData()">Fetch</v-btn>
                    </v-col>
             </v-row> -->
       </v-card>     
       <!-- {{canteen_menu_list}} -->
     <v-card class="box" v-if="this.canteen_menu_list!=''">
     <v-data-table class="elevation-1 mytable" dense :headers="headers" :items="canteen_menu_list" :items-per-page="-1" :search="search">
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Parental Menu Control</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
             <v-card-title>
                <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                  ></v-text-field>
                  </v-card-title>
        </template>
         <template v-slot:[`item.islocked`]="{ item }">
          <v-row dense>
            <span v-if="!item.islockedforchild">
                  <v-icon class="mt-4 mr-2 v-icon-size" color="success">mdi-lock-open-variant-outline</v-icon>
            </span>
            <span v-else>
               <v-icon class="mt-4 mr-2 v-icon-size" color="error">mdi-lock-outline</v-icon>
            </span>
                 <v-switch v-model="item.islockedforchild"  @change="toggleParentalControl(item)"></v-switch>
                 </v-row>
        </template>
     </v-data-table>
 </v-card>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";  
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      search:"",
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      headers:[
      // { text: "SR No", value: "count" },
      { text: "Manu Id", value: "menuid" },
      { text: "Manu Type", value: "canteenmenutype" },
      { text: "Manu Category", value: "canteenmenucategory" },
      { text: "Name", value: "name" },
      { text: "Rate", value: "rate" },
      { text: "Is Locked", value: "islocked" },
      ],
      child_list:[],child:"",menu_type_list:[],menu_type:"",show_menu_type_list:false,canteen_menu_list:[], dialog_edit: false,
  }),
   methods: {
    toggleParentalControl(item){
         //if (!confirm("Are You Sure You Want To Block This Menu...?")) return;
         const data = {
            child: this.child,
            menu_id: item.id,
      };
      this.overlay = true;
      axios
        .post("/Canteen/toggleParentalControl", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.canteen_menu_list = res.data.canteen_menu_list;
            this.showSnackbar("green","Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    fetchData(){
         const data = {
            child: this.child,
            menu_type: this.menu_type,
      };
      this.overlay = true;
      axios
        .post("/Canteen/fetchParentalControlData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.canteen_menu_list = res.data.canteen_menu_list;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getMenuTypeList(){
        this.show_menu_type_list=true
    },
    onLoad() {
        axios
            .post("Canteen/parentalMenuControl")
            .then((res) => {
                if (res.data.flag == "YES") {
                    this.child_list = res.data.learner_list;
                    this.menu_type_list = res.data.menu_type_list;
                   // this.canteen_menu_list = res.data.canteen_menu_list;
                    this.overlay = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
            });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>